import { Component, Input } from '@angular/core';
import { LoadingService } from 'ng-devui';
import { catchError, throwError, zip } from 'rxjs';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { ArchiveCatalog } from 'src/app/modules/shared/models/archive/archive-catalog.model';
import { ArchiveFileSyncRuleType } from 'src/app/modules/shared/models/archive/archive-file-sync-rule-type.enum';
import { ArchiveFileSyncRule } from 'src/app/modules/shared/models/archive/archive-file-sync-rule.model';
import { MaterialType } from 'src/app/modules/shared/models/material/material-type.model';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { ArchiveCatalogService } from 'src/app/modules/shared/services/archive-catalog.service';
import { MaterialTypeService } from 'src/app/modules/shared/services/material-type.service';
import { ProjectSectionService } from 'src/app/modules/shared/services/project-section.service';
import { ProjectWbsService } from 'src/app/modules/shared/services/project-wbs.service';

@Component({
  selector: 'app-dialog-projects-profiles-volumn-sync',
  templateUrl: './dialog-projects-profiles-volumn-sync.component.html',
  styleUrls: ['./dialog-projects-profiles-volumn-sync.component.scss'],
})
export class DialogProjectsProfilesVolumnSyncComponent {
  @Input()
  data!: DialogConfig<ArchiveCatalog>;

  editing: { [name: string]: boolean } = {};

  record: ArchiveCatalog = new ArchiveCatalog();

  // sectionNodes: Array<NzTreeNode> = [];

  materialTypeList = [] as Array<MaterialType>;

  materialTypeListSelected: string[] = [];

  formArchiveFileSyncRule = new ArchiveFileSyncRule(
    ArchiveFileSyncRuleType.FORM,
  );
  materialArchiveFileSyncRule = new ArchiveFileSyncRule(
    ArchiveFileSyncRuleType.MATERIAL,
  );

  sectionMap: { [key: string]: ProjectSection } = {};

  cover: string = '';

  title: string = '';

  constructor(
    private archiveCatalogService: ArchiveCatalogService,
    private projectWbsService: ProjectWbsService,
    private materialTypeService: MaterialTypeService,
    private projectSectionService: ProjectSectionService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit() {
    this.prepare();
  }

  prepare() {
    zip(
      this.materialTypeService.findAll({}),
      this.archiveCatalogService.findById(this.data.data!.id!),
    ).subscribe(([materialTypes, data]) => {
      this.cover = '全部标段';
      if (this.data.data?.sectionId) {
        this.projectSectionService
          .findById(this.data.data!.sectionId!)
          .subscribe((section) => {
            this.cover = section.name!;
            if (this.data.data?.sectionItemId) {
              this.projectWbsService
                .findAll({
                  projectId: this.data.data!.projectId!,
                  sectionItemId: this.data.data!.sectionItemId!,
                  sectionId: this.data.data!.sectionId!,
                })
                .subscribe((wbs) => {
                  if (wbs?.length > 0) {
                    const codeList = wbs[0].fullCode?.split('.') || [];
                    const nameList = wbs[0].fullName?.split('\\') || [];
                    if (codeList.length > 0) {
                      for (let i = 0; i < codeList.length; i++) {
                        this.cover += ' \\ ';
                        this.cover += codeList[i];
                        if (i < nameList.length) {
                          this.cover += ' ' + nameList[i];
                        }
                      }
                    }
                  }
                });
            }
          });
      }
      this.materialTypeList = materialTypes;
      this.handleDataBeforeInit(data);
    });
  }

  private handleDataBeforeInit(response: ArchiveCatalog) {
    const data = JSON.parse(JSON.stringify(response)) as ArchiveCatalog;
    for (const rule of data.fileSyncRules ?? []) {
      if (rule.type === ArchiveFileSyncRuleType.FORM) {
        this.formArchiveFileSyncRule = rule;
      } else if (rule.type === ArchiveFileSyncRuleType.MATERIAL) {
        this.materialArchiveFileSyncRule = rule;
        if (rule.checked && rule.content) {
          this.materialTypeListSelected = rule.content.split(';');
        }
      }
    }
    this.record = data;
  }

  isNaN(content: number) {
    return window.isNaN(content);
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    this.submit();
  }

  get canConfirm() {
    return true;
  }

  private submit() {
    const loading = this.loadingService.open();
    this.archiveCatalogService
      .syncFile(this.data.data!.id!)
      .pipe(
        catchError((err) => {
          loading.loadingInstance.close();
          return throwError(err);
        }),
      )
      .subscribe((res) => {
        loading.loadingInstance.close();
        if (res) {
          this.data.onConfirm!();
        }
      });
  }
}
